module.exports = __webpack_public_path__ + "media/shingles/hero-f4650cfe.jpg";